import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Skeleton } from '@material-ui/lab';
import { MenuItem, MenuList, Paper } from '@material-ui/core';

import { useGetListCustomerGroupsQuery } from 'core/services';
import { getArray } from 'utils/helpers';
import useIsLoading from 'hooks/useIsLoading.hook';
import Icon from 'components/Icon';
import IconButton from 'components/IconButton';
import Popper from 'components/Popper';

const LabList = ({ classes }) => {
  const [chemistryMenu, setChemistryMenu] = useState(null);

  const queryLabGroups = useGetListCustomerGroupsQuery(undefined, {
    skip: !chemistryMenu,
  });
  const labList = getArray(queryLabGroups.data);
  const loading = useIsLoading(queryLabGroups);

  const handleCloseProfile = () => {
    setChemistryMenu(null);
  };

  const handleTogglePopper = ({ currentTarget }) => {
    setChemistryMenu((prev) => (prev ? null : currentTarget));
  };

  return (
    <div>
      <IconButton
        size="medium"
        className={classes.iconButton}
        onClick={handleTogglePopper}
      >
        <Icon.TestTubes3 />
      </IconButton>
      <Popper
        anchorEl={chemistryMenu}
        open={Boolean(chemistryMenu)}
        onClose={handleCloseProfile}
      >
        <Paper className={classes.chemistryPaper}>
          <MenuList className={classes.chemistryList}>
            {loading &&
              new Array(3).fill(null).map((v, index) => (
                <MenuItem key={index}>
                  <Skeleton variant="rect" height={30} width="100%" />
                </MenuItem>
              ))}

            {!loading &&
              labList.map((lab) => (
                <MenuItem
                  onClick={handleCloseProfile}
                  component={Link}
                  to={'/profile/lab'}
                  key={lab.id}
                >
                  {lab.title}
                </MenuItem>
              ))}

            <MenuItem
              className=".create-lab"
              onClick={handleCloseProfile}
              component={Link}
              to={'/profile/lab#create'}
            >
              Create Lab Group
            </MenuItem>
          </MenuList>
        </Paper>
      </Popper>
    </div>
  );
};

export default LabList;
